import React from "react";

const Loading = () => {
  return (
    <div className="loader-wrap">
      <div className="loader-inner">
        <div className="loader-inner-cirle"></div>
      </div>
    </div>
  );
};

export default Loading;
